/* eslint-disable no-promise-executor-return */
/* eslint-disable brace-style */
/* eslint-disable eqeqeq */
/* eslint-disable no-async-promise-executor */
/* eslint-disable no-restricted-globals */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { uniqueId, get, isArray, every, isString, isEmpty, isNull } from 'lodash';
import { Amplify } from 'aws-amplify';
import { clearCredentials } from '@aws-amplify/core';
import { signOut, fetchAuthSession } from '@aws-amplify/auth';
import { AUTH_KEY_PREFIX } from '@aws-amplify/auth/cognito';
import {
    preInit,
    initializeToken,
    userpermissionsCheck,
    handleRefreshSuccess,
    featureConfiguration,
    removeSessionFilters,
} from './MeActions.js';
import { getAddressFormatConfiguration } from './configurationActions.js';
import { getReturnsCart } from './returnActions.js';
import coreSettings from '../helpers/default-settings.js';
import constants from '../helpers/constants.js';
import MDTNotification from '../components/molecules/mdt-notification/index.js';
import MDTTimerNotification from '../components/molecules/mdt-timer-notification/index.js';
import { MDTApi } from '../services/mdtapi.js';
import { MDTAnalytics } from '../services/mdtanalytics.js';
import manualAwsConfig from '../constants/awsConfig/awsConfig.js';
import { autoOnboard } from '../services/meService.js';
import { sanitizeBEProperties, sendEventTrackingData } from '../helpers/commonUtils.js';
import { AnalyticsConstants } from '../helpers/analyticsConstants.js';

window.MDTSetting = window.MDTSetting || {};
// exposing register settings to support legacy bu-settings

window.MDTApp = {};
window.MDTApp.registerSettings = function (response) {
    MDTSetting = mergeDeep(MDTSetting, response);
    MDTSetting.pathVars = response || {};
    MDTApi.setDefaultPathVar('appid', MDTSetting.appid);
};

/**
 * Exposes internal methods that can be replaced with Cypress mocks at runtime.
 * Callers destructure what they need: const { signOut } = getMockableDeps();
 * To mock a method in Cypress, add it to window.__amplifyAuthMock__ — any key
 * present there will override the real implementation when destructured.
 * NOTE: Same pattern as getAuthMethods in dashboard 20260302:Alevale
 */
const getMockableDeps = () => {
    if (window.Cypress && window.__amplifyAuthMock__) {
        return window.__amplifyAuthMock__;
    }
    return { signOut, replicateCognitoLogout };
};

let SSOclick = true;
// Private (NON-Export )function

/**
 * Simple object check.
 * @param item
 * @returns {boolean}
 */
function isObject(item) {
    return item && typeof item === 'object' && !Array.isArray(item);
}

function idleLogout() {
    let t;
    window.addEventListener('mousemove', resetTimer);
    window.addEventListener('keydown', resetTimer);
    window.addEventListener('scroll', resetTimer);

    function notifyUser() {
        window.removeEventListener('scroll', resetTimer);
        window.removeEventListener('mousemove', resetTimer);
        window.removeEventListener('keydown', resetTimer);
        showNotification(
            window.t('sessionTimeOutMessage'),
            'information',
            window.t('SessionTimeOut'),
            window.t('Ok'),
            function () {
                window.location.reload();
            },
            {
                timer: MDTSetting.sessionTimoutTimer || 60,
                sessionTimeOutCallBack: () => {
                    logout();
                },
                unit: window.t('seconds'),
            }
        );
    }

    function resetTimer() {
        clearTimeout(t);

        t = setTimeout(notifyUser, MDTSetting.idleTime || 1800000); // time is in milliseconds
    }
}

let xhrNotifyElement = null;
function showNotification(msg, type, title, buttonLevel, callback, sessionTimeOutNotification) {
    if (!msg) {
        console.log('Notification Message should not be undefined.....................');
        return;
    }

    const props = {
        contents: [msg],
        defaultOpen: true,
        button: buttonLevel || '',
        notifyType: type || 'error',
        title: title,
        key: uniqueId('id_'),
    };
    if (callback) props.toggle = callback;
    const elementName = 'xhrNotify';
    let element = document.getElementById(elementName);

    if (!element) {
        element = document.createElement('div');
        element.setAttribute('id', 'xhrNotify');
        document.body.appendChild(element);
    }
    if (!xhrNotifyElement) {
        xhrNotifyElement = ReactDOM.createRoot(document.getElementById(elementName));
    }

    // TODO: Refactor this, add <MDTTimerNotification /> to the
    //  skeleton and write here to redux just if it should
    //  be shown or not  20231027:Alevale
    if (sessionTimeOutNotification) {
        const timerNoficationProps = {
            ...props,
            timer: sessionTimeOutNotification.timer,
            timerCallback: sessionTimeOutNotification.sessionTimeOutCallBack,
            unit: sessionTimeOutNotification.unit,
        };
        xhrNotifyElement.render(<MDTTimerNotification {...timerNoficationProps} />);
    } else {
        xhrNotifyElement.render(<MDTNotification {...props} />);
    }
}

function registerSettings(resolve) {
    MDTSetting = mergeDeep(MDTSetting, coreSettings);
    return getAppSettings(resolve);
}

function getAppSettings(resolve) {
    const { appSettings } = window;
    MDTSetting = mergeDeep(MDTSetting, appSettings);

    getSetting('fetchApiConfg', false) && registerAppApiSettings();
    getSetting('configurationServerEnabled', false) && registerConfigServerApiSettings();
    return resolve();
}

function registerAppApiSettings() {
    return MDTApi.call('appApi', {
        method: 'GET',
        cache: true,
        headers: { Authorization: 'no auth' },
        errorCallback: handleError,
        successCallback: function (data) {
            window.MDTSetting = mergeDeep(MDTSetting, data);
        },
    });
}
function registerConfigServerApiSettings() {
    MDTApi.setDefaultPathVar('appid', MDTSetting.appid);
    MDTApi.setDefaultPathVar('env', MDTSetting.features.environment);
    return MDTApi.call('api.configServer', {
        method: 'GET',
        cache: true,
        errorCallback: handleError,
        successCallback: function (data) {
            const configs = Object.assign(...data.propertySources.map((i) => i.source));
            window.MDTSetting = mergeDeep(MDTSetting, configs);
        },
    });
}
function handleError() {
    console.log('error');
}

const handlePostLoginAuthenticationRedirects = (dispatch, token) => {
    return new Promise((resolve) => {
        if (!token || isEmpty(token)) {
            // NOTE: This should be redirecting to the login, BUT to do so we need to change also the `authenticate`
            // function this should be in a refactor, not on a small release improvement 20250702:Alevale
            resolve('UNAUTHORIZED');
            return;
        }
        // NOTE: If the user is internal, and they need onboarding, they have to
        // be either auto-onboarded or manually-onboarded, auto-onboard API
        // will return empty if needed to be manual 20250702:Alevale
        if (sanitizeBEProperties(token, 'isinternal') === 'true') {
            if (sanitizeBEProperties(token, 'ApplyOnboarding') === 'true') {
                return autoOnboard()
                    .then((user) => {
                        if (user) {
                            resolve(user);
                            // NOTE: Since the user has been auto-onboarded, re-issue the initBootstrap
                            // to get a new token and reinitialize the application this won't be an infinite
                            // loop since the user won't have this properties anymore 20250702:Alevale
                            dispatch(initBootstrap(resolve));
                            return;
                        }

                        // NOTE: If there's no user, we need to redirect to the accountSetup page 20250702:Alevale
                        dispatch({ type: 'ACCOUNTSETUP' });
                        resolve('ACCOUNTSETUP');
                    })
                    .catch((error) => {
                        console.error('Error during autoOnboard:', error);
                        // NOTE: Although this is not perfect since there was an error, the user
                        // is still authorized so continue with the flow 20250703:Alevale
                        resolve('AUTHORIZED');
                    });
            }
        }

        // NOTE: If the user doesn't exist in our system, the token will NOT be decorated, which we can use
        // to know if they have to go to the "requestAccess" screen 20250430:Alevale
        if (!MDTApp.userExistsInConnect(token)) {
            if (!window.location.pathname.includes('requestAccess')) {
                dispatch({ type: 'REQUESTACCESS' });
            }
            resolve('REQUESTACCESS');
        }

        resolve('AUTHORIZED');
    });
};

/**
 * This function is used to know if the user has just been registered in the external IdP, but not on our system
 * we will know this because the user will not contain any information (userInfo call will be empty)
 * we will assume that the user doesn't exist if they are not decorated with roles or internal values
 * 20250430:Alevale
 * @param user
 * @return {boolean}
 */
const userExistsInConnect = (user = {}) => {
    return (
        user &&
        user?.userRolesCount &&
        ['isRolesCountMax', 'isInternal'].every((key) =>
            Object.keys(user).join().toLowerCase().includes(key.toLowerCase())
        )
    );
};

// Public (Export) function
function getResourceAccess(resourceName, resourcePermission) {
    return (dispatch, getState) => {
        const resource = get(getState(), 'meDetails.resourceAccess', []);
        return (
            resource.length > 0 &&
            !!resource.find(
                (obj) => obj.resource === resourceName && obj.actions.includes(resourcePermission)
            )
        );
    };
}

function createQueryStringParam(object) {
    return Object.keys(object)
        .map((key) => {
            return `${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`;
        })
        .join('&');
}

const getAwsConfig = () => (isEmpty(window.awsConfig) ? manualAwsConfig : window.awsConfig);

const initAmplify = () => {
    const alreadyConfigured = Amplify.getConfig();
    if (alreadyConfigured) {
        console.warn('[AWS] Amplify already configured');
    }

    Amplify.configure(getAwsConfig());
};

function initBootstrap(resolveStore) {
    return (dispatch, getState) => {
        new Promise(function (resolve) {
            registerSettings(resolve);
        })
            .then(async function () {
                initAmplify();
            })
            .then(function () {
                dispatch(preInit());
            })
            .then(function () {
                return new Promise(async (resolve) => {
                    await initializeToken(dispatch, getState, resolve);
                }).catch(function (error) {
                    console.log(error);
                });
            })
            .then(function () {
                return handlePostLoginAuthenticationRedirects(
                    dispatch,
                    getState().cognitoTokens?.accessToken
                )
                    .then((res) => {
                        // NOTE: If we should go to requestAccess or accountSetup and we're not
                        // in the portal app, redirect to there through the portal app 20250707:Alevale
                        if (res === 'REQUESTACCESS' || res === 'ACCOUNTSETUP') {
                            if (window.routeSettings.appRoute !== 'portal') {
                                MDTApp.goto(MDTApp.getSetting(`links.${res}`));
                            }
                        }
                    })
                    .catch((error) => {
                        console.error(
                            'Error during handlePostLoginAuthenticationRedirects:',
                            error
                        );
                    });
            })
            .then(function () {
                // NOTE: Let's keep this logic in place for now, touch this on the authentication post cleanup 20250702:Alevale
                dispatch(authenticate());
            })
            .then(function () {
                return new Promise((resolve) => {
                    // NOTE: If the user doesn't exist in connect, do nothing here 20250430:Alevale
                    const user = get(getState(), 'meDetails.user', {});
                    if (!userExistsInConnect(user)) {
                        resolve();
                        return;
                    }
                    dispatch(getPermissions(resolve));
                });
            })
            .then(function () {
                const customerId = get(getState(), 'meDetails.defaultCustomer.id', undefined);
                const me = getState().meDetails && getState().meDetails.meState;
                const user = get(getState(), 'meDetails.user', {});
                const isLoggedIn = me.LOGGED_IN;
                // NOTE: If the user doesn't exist in connect, do nothing here 20250430:Alevale
                if (!userExistsInConnect(user)) {
                    return;
                }

                if (customerId) {
                    // For Consignment_Purchaser user role, ZOR ordertype will be change to KB ordertype so sending customerId to get configuration.
                    dispatch(featureConfiguration(customerId)).then(() => {
                        if (
                            getSetting('login.autofetchWishlist', true) &&
                            dispatch(getResourceAccess('Cart', 'Write'))
                        ) {
                            return new Promise((resolve) => {
                                dispatch(fetchWishlist(resolve));
                            });
                        }
                    });
                } else {
                    // NOTE: If the APP doesn't have a customer it could still have configuration, so call it 20220609:Alevale
                    if (isLoggedIn) {
                        return new Promise((resolve) => {
                            dispatch(featureConfiguration()).then(() => {
                                return resolve();
                            });
                        });
                    }
                }

                isLoggedIn && idleLogout();
            })
            .then(function () {
                if (resolveStore) return resolveStore();
            })
            .then(function () {
                const territoryId = getState()?.meDetails?.customer?.territory?.id || 'default';
                const addressFormat = getSetting('login.addressFormat', true);
                // added confg setting to turn off addressFormat API
                addressFormat && dispatch(getAddressFormatConfiguration(territoryId));
                dispatch(MDTAnalytics.cacheUser(getDeviceType()));
            })
            .catch((e) => {
                console.error('Error during initBootstrap:', e);
            });
    };
}

/**
 * Deep merge two objects.
 * @param target
 * @param ...sources
 */
function mergeDeep(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();

    if (isObject(target) && isObject(source)) {
        for (const key in source) {
            if (isObject(source[key])) {
                if (!isObject(target[key]))
                    Object.assign(target, {
                        [key]: {},
                    });
                mergeDeep(target[key], source[key]);
            } else {
                Object.assign(target, {
                    [key]: source[key],
                });
            }
        }
    }

    return mergeDeep(target, ...sources);
}

function getSetting(key, defaultValue, flatProcessUrl) {
    const collection = MDTSetting;

    if (typeof key !== 'string') {
        console.error('MDTApp.getSetting: parameter must be a string');
        return undefined;
    }
    const arPath = key.split('.');
    let result = collection;
    for (let i = 0; i < arPath.length; i++) {
        if (result[arPath[i]] !== undefined) {
            result = result[arPath[i]];
        } else {
            return defaultValue || false;
        }
    }

    if (flatProcessUrl) {
        return MDTApi.processPathVariables(result, MDTSetting.pathVars);
    }

    return result;
}

const whitelistedUrl = (location) => {
    // NOTE: We rely on the routemap to see if the page is accessible.
    // When the page was defined with "externallyAccessible: true" then
    // we don't make a redirect to the login 20201201:Alevale
    return get(location.routesMap, `${location.type}.externallyAccessible`, false);
};

function authenticate() {
    // let deferred = new $.Deferred();
    return (dispatch, getState) => {
        const location = getState().location || {};
        const currentLocation = location.routesMap.catalog;

        const appId = getSetting('appid');
        const requiresAuthentication = getSetting('login.autoCheckLogin', true);
        const me = getState().meDetails.meState || {};
        const isLoginPage = getQueryStringParam('login', currentLocation, false);

        if (whitelistedUrl(location)) {
            return;
        }

        if (requiresAuthentication) console.log('init', appId, 'authenticating...');
        let redirection =
            location.type === 'LOGIN' ||
            location.type === 'FORGOTPASSWORD' ||
            location.type === 'REQUESTACCESS'
                ? 'PORTAL'
                : location.type;
        if (
            (location.type === 'LOGIN' ||
                location.type === 'FORGOTPASSWORD' ||
                location.type === 'REQUESTACCESS') &&
            me.LOGGED_IN
        ) {
            //  goto(getSetting(prevPath));
            console.log('init', appId, 'redirecting to previous page...', redirection);
            dispatch({ type: redirection });
        } else if (requiresAuthentication && !me.LOGGED_IN && !isLoginPage) {
            redirection =
                location.type !== 'LOGIN' ||
                location.type !== 'FORGOTPASSWORD' ||
                location.type !== 'REQUESTACCESS'
                    ? 'LOGIN'
                    : location.type;
            const queryParams = getState().location?.query;
            console.log('init', appId, 'redirecting to login page...', redirection, queryParams);
            dispatch({ type: redirection, query: queryParams });
        }
    };
}

function isAvailable(state, meState) {
    if (!isArray(state)) state = [state];
    return (
        state.length &&
        every(state, function (s) {
            return isString(s) && !!meState[s];
        })
    );
}

function getPermissions(resolve) {
    return (dispatch, getState) => {
        const requiresAuthorization = getSetting('login.autoCheckPermissions', true);
        const appId = getSetting('appid');
        const buId = getSetting('buid');
        const me = getState().meDetails.meState || {};
        const loggedIn = me.LOGGED_IN;

        function inAcceptingState() {
            return !requiresAuthorization || isAvailable(me.HAS_PERMISSIONS, me);
        }

        if (!inAcceptingState() && !isAvailable(me.FETCHING_PERMISSIONS, me) && loggedIn) {
            dispatch(userpermissionsCheck(dispatch, getState, resolve, appId, buId));
        } else {
            resolve && resolve(getState);
        }
    };
}

function getDeviceType() {
    const a = navigator.userAgent || navigator.vendor || window.opera;
    let check = 'desktop';
    if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge|maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
            a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
        )
    ) {
        check = 'mobile';
    }
    return check;
}

function processUrl(urlFragment, pathVars) {
    // Process path variables
    if (!isEmpty(pathVars)) {
        urlFragment = MDTApi.processPathVariables(urlFragment, pathVars);
    }

    let url = '';

    // Given url fragment is starting by a pathname. E.g.: /apps/eservices/
    if (urlFragment.substring(0, 1) === '/') {
        // Eg. of recomposed URL => 'http:' + '//' + 'medtronic.local' + '/apps/eservices/#/order-approval/00025017'
        url = `${window.location.protocol}//${window.location.host}${urlFragment}`;
    }

    // Given url fragment is starting by a hash. E.g.: #/order-approval/00025017
    else if (urlFragment.substring(0, 1) === '#') {
        // Eg. of recomposed URL =>  'http:' + '//' + 'medtronic.local' + '/apps/eservices/' + '#/order-approval/00025017'
        url = `${window.location.protocol}//${window.location.host}${
            window.location.pathname
        }${urlFragment}`;
    }

    // Given url fragment is starting by search term. E.g.: ?hello=world#/order-approval/00025017
    else if (urlFragment.substring(0, 1) === '?') {
        // Eg. of recomposed URL =>  'http:' + '//' + 'medtronic.local' + '/apps/eservices/' + '?hello=world#/order-approval/00025017'
        url = `${window.location.protocol}//${window.location.host}${
            window.location.pathname
        }${urlFragment}`;
    } else {
        // Given url fragment is starting with a valid protocol
        const re = /([a-z]*:)/;
        const m = re.exec(urlFragment);

        if (m && m.length > 1) {
            url = urlFragment;
        }

        // Not recognized URL format
        else {
            console.error(`Not recognized URL format: ${urlFragment}`);
            url = window.location.href;
        }
    }

    return url;
}

function navigateToUrl(url, pathVars) {
    window.location.href = processUrl(url, pathVars);
}

function goto(url, pathVars) {
    if (!url) {
        throw new Error('URL is not provided!');
    }

    if (!window?.reduxStore?.dispatch) {
        return navigateToUrl(url, pathVars);
    }

    window?.reduxStore?.dispatch((dispatch, getState) => {
        const { location, blockNavigation = {} } = getState();
        const { pathname: currentPage, routesMap } = location || {};

        const currentRoute = Object.keys(routesMap || {}).find(
            (route) => routesMap[route]?.path === currentPage
        );
        const { shouldPromptLeaveConfirmation } = routesMap[currentRoute] || {};

        if (!shouldPromptLeaveConfirmation || blockNavigation?.bypassBlockNavigation) {
            return navigateToUrl(url, pathVars);
        }

        const canLeaveCallback = (can) => {
            dispatch({ type: 'HIDE_BLOCK_NAVIGATION_MODAL' });
            if (can) {
                navigateToUrl(url, pathVars);
            }
        };
        dispatch({
            type: 'SHOW_BLOCK_NAVIGATION_MODAL',
            payload: {
                message: 'leavingPageConfirmation',
                canLeaveCallback,
            },
        });
    });
}

function getQueryStringParam(key, uri, mustDecodeUriComponent) {
    if (mustDecodeUriComponent !== false) {
        mustDecodeUriComponent = true;
    }

    const href = uri || window.location.href;
    const reg = RegExp(key, 'g'); // new RegExp('[?&]' + key + '=([^&#\/]*)', 'i');
    const string = reg.exec(href) || false;
    if (!string) {
        return false;
    }
    if (mustDecodeUriComponent) {
        return isNull(string) ? null : decodeURIComponent(string[1]);
    }
    return isNull(string) ? null : string[1];
}

function storeWishListId(data) {
    return { type: constants.USER_WISHLIST_ID_NAME, data };
}

function storeWishCount(data) {
    return { type: constants.USER_WISHLIST_COUNT, data };
}

function fetchWishlist(resolve) {
    return (dispatch, getState) => {
        const state = getState();
        const defaultCartType = get(
            state,
            'formConfig.featureConfiguration.DefaultCartType.configuration.cartType',
            'DEFAULT'
        );
        return MDTApi.call(
            'api.wishlist.cart',
            {
                method: 'GET',
                params: {
                    cartType: defaultCartType,
                },
                successCallback: function (data) {
                    dispatch(storeWishListId(data[0]));
                    dispatch(loadWishlistCount(data[0].wishListId));
                    // dispatch(loadWishlist(data[0].wishListId));
                    resolve && resolve();
                },
            },
            {},
            getSetting('countLoader', true)
        );
    };
}

function saveWishlistData(data) {
    return { type: constants.USER_WISHLIST_ENTRIES, data };
}

function loadWishlistCount() {
    return (dispatch, getState) => {
        dispatch(MDTApp.getResourceAccess('Returns', 'Read')) &&
            dispatch(MDTApp.getResourceAccess('ReturnProducts', 'Feature')) &&
            dispatch(getReturnsCart());
        MDTApi.setDefaultPathVar('cartid', getState().wishList.wishListId);
        return MDTApi.call(
            'api.wishlist.cartCount',
            {
                method: 'GET',
                successCallback: function (data) {
                    dispatch(storeWishCount(data));
                },
            },
            {},
            getSetting('countLoader', true)
        );
    };
}

function loadWishlist() {
    return (dispatch, getState) => {
        MDTApi.setDefaultPathVar('cartId', getState().wishList.wishListId);
        return MDTApi.call('api.quickOrder.addToCart', {
            method: 'GET',
            successCallback: function (data) {
                dispatch(saveWishlistData(data));
            },
        });
    };
}

const removeAnalyticsTrackers = () => {
    sessionStorage.removeItem('deviceRegistrationId');
    sessionStorage.removeItem('allEventsStore');
    sessionStorage.removeItem('allPageLoadData');
    sessionStorage.removeItem('transactions');
    sessionStorage.removeItem('transaction');
};

const postLogoutCleanup = () => {
    // NOTE: Given how the external IdP logout works we need a reference to the
    // provider id_token to also log them off from there 20250425:Alevale
    localStorage.removeItem('customer');
    sessionStorage.setItem('isRolesCountMax', 'false');
    sessionStorage.removeItem('apiRefreshToken');
    localStorage.removeItem('apiToken');

    removeAnalyticsTrackers();
    removeSessionFilters();
};

async function currentSession() {
    try {
        const authSession = await fetchAuthSession();
        const { accessToken, idToken } = authSession.tokens ?? {};
        return { accessToken, idToken };
    } catch (err) {
        console.info(err);
        return { accessToken: null, idToken: null };
    }
}

const sendLogoutTrackingData = async () => {
    // Add access to the store
    const { accessToken } = await currentSession();
    const isInternal = accessToken
        ? sanitizeBEProperties(accessToken, 'isinternal') === 'true'
        : false;

    const userType = isInternal
        ? AnalyticsConstants.categories.internal
        : AnalyticsConstants.categories.external;
    const dateTime = new Date().toJSON();
    const trackingLabel = `Logout_${userType} : ${dateTime}`;
    const eventParamObj = {
        eventCategory: 'accManagement',
        eventAction: 'logout',
        eventLabel: trackingLabel,
        processActions: false,
        processLabels: false,
    };
    sendEventTrackingData(eventParamObj);

    // NOTE: Send an immediate tracking event to adobe, and hope this kicks the
    // adobe store, as it will be gone after logout 20250715:Alevale
    if (typeof window._satellite !== 'undefined') {
        window._satellite.track('logout');
    }
};

/**
 * NOTE: Redirect to Cognito /logout endpoint for OAuth logout flow
 * this replicates what Amplify's signOut() does: calls Cognito /logout which then
 * redirects to portal logout, where authGuard.js handles the external IdP logout 20251028:Alevale
 *
 * @returns {void}
 */
const replicateCognitoLogout = () => {
    try {
        const config = getAwsConfig();
        const domain = config?.Auth?.Cognito?.loginWith?.oauth?.domain;
        const clientId = config?.Auth?.Cognito?.userPoolClientId;
        const logoutUri = `${window.location.origin}/apps/portal/logout`;

        if (domain && clientId) {
            window.location.href = `https://${domain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
        } else {
            console.error(
                '[LOGOUT] Cannot construct Cognito logout URL - missing domain or clientId'
            );
        }
    } catch (error) {
        console.error('[LOGOUT] Error during replicateCognitoLogout:', error);
    }
};

/**
 * This is a fallback mechanism so that the user can sign out regardless of AWS giving errors
 * This is a temporary solution until we can get the root cause for the configuration issue
 *
 * NOTE: Manual implementation replicates essential logout behavior from:
 * @aws-amplify/auth/dist/cjs/providers/cognito/apis/signOut.js 20251028:Alevale
 *
 * @returns {Promise<void>}
 */
const manualSignOutFallback = async () => {
    const { replicateCognitoLogout } = getMockableDeps();

    try {
        await clearCredentials();
    } catch (credError) {
        console.error('[LOGOUT] Error clearing credentials:', credError);
    }

    // NOTE: Amplify signOut failed (likely AuthUserPoolException) - nuke everything manually
    // Clear ALL Cognito tokens from localStorage 20251028:Alevale
    Object.keys(localStorage)
        .filter((key) => key.includes(AUTH_KEY_PREFIX))
        .forEach((key) => {
            localStorage.removeItem(key);
        });

    postLogoutCleanup();

    replicateCognitoLogout();
};

async function logout() {
    const { signOut } = getMockableDeps();

    try {
        await sendLogoutTrackingData();

        await signOut({
            global: true,
            oauth: {
                // NOTE: Send here a URL that we can capture as the logout (the external IdP logout can't be managed from here)
                // ideally we would go directly from here to the IdP URL, but we can't since the "id_token_hint"
                // is variable, and it has to be a fixed URL (callbacks can't have wildcards)  20250312:Alevale
                redirectUrl: `${window.location.origin}/apps/portal/logout`,
            },
        });
        // NOTE: Remove cognitoTokens 20250519:Alevale
        Object.keys(localStorage)
            .filter((a) => a.includes(AUTH_KEY_PREFIX))
            .map((a) => localStorage.removeItem(a));
        postLogoutCleanup();
    } catch (error) {
        console.error('[LOGOUT] Amplify signOut failed:', error);
        manualSignOutFallback();
    }
}

// TODO: Remove this as it's not used anymore (although it's referenced) 20250829:Alevale
function updateCheckoutData(data) {
    return (dispatch) => {
        dispatch(saveCheckoutData(data));
    };
}

function setLoginData(data) {
    return (dispatch, getState) => {
        new Promise(async function (resolve) {
            await handleRefreshSuccess(data, dispatch, getState, resolve);
        })
            .then(async function () {
                const appId = getState().meDetails.user.defaultApp.toLowerCase();
                const ssoCheck = getState().meDetails.user.sso == 'True';
                const authSession = await fetchAuthSession();
                const decodedAccessToken = authSession.tokens?.accessToken?.payload || {};
                const isInternal = getState().meDetails.user.isinternal;
                const me = getState().meDetails && getState().meDetails.meState;
                const isLoggedIn = me.LOGGED_IN;
                isLoggedIn && idleLogout();

                if (
                    (appId !== 'portal' && decodedAccessToken.password !== 'must_change_now') ||
                    isInternal == 'True'
                ) {
                    if (ssoCheck) {
                        dispatch(MDTApp.sso());
                    } else {
                        const { appLink } = getState().meDetails.user;
                        goto(appLink);
                    }
                }
            })
            .catch(function (error) {
                console.error('Error setting login data:', error);
            });
    };
}

function saveCheckoutData(data) {
    return { type: constants.CHECKOUT_ITEMS_LIST, data };
}

export function saveScreenOverlay(data) {
    return { type: constants.GET_SCREEN_OVERLAY, data };
}

function isMobile() {
    const width = window.innerWidth > 0 ? window.innerWidth : screen.width;
    return width < constants.TABLET_WIDTH;
}

function isTablet() {
    const width = window.innerWidth > 0 ? window.innerWidth : screen.width;
    return width >= constants.TABLET_WIDTH && width < constants.DESKTOP_WIDTH;
}

function isMobileOrTablet() {
    const width = window.innerWidth > 0 ? window.innerWidth : screen.width;
    return width < 1024;
}

function isDesktop() {
    const width = window.innerWidth > 0 ? window.innerWidth : screen.width;
    return width >= constants.DESKTOP_WIDTH;
}

function setTileAction(data) {
    return { type: constants.PORTAL_TILES, data };
}

function sso(redirectURL, url) {
    return (dispatch, getState) => {
        if (window.refreshTokenFlag && SSOclick) {
            SSOclick = false;
            console.log('redirecting');
            const userId = getState().meDetails.user.sub || [];
            MDTApp.myloginRedirect(userId, redirectURL, url);
        } else {
            window.setTimeout(MDTApp.sso, 1000);
        }
    };
}

function myloginRedirect(userId, redirectURL, url) {
    // NOTE: This is where we send the API token to myorders 20250425:Alevale
    const token = `Bearer ${localStorage.getItem('apiToken')}`;
    const redirectionLink =
        MDTApp.getSetting('myorderurl') ||
        window.t(`myorders.ssologin.${window.location.host.split('.')[0]}`) ||
        '';
    const data = {
        userId: userId,
        token: encodeURIComponent(token),
        language: 'en_US',
    };

    // NOTE: This is how we can access the refresh_token with the amplify library 20250423:Alevale
    data.refreshToken =
        localStorage[
            Object.keys(localStorage)
                .filter((a) => a.includes(AUTH_KEY_PREFIX))
                .filter((a) => a.includes('refresh'))
        ] || '';

    if (redirectURL) {
        data.redirectURL = url;
    }
    MDTApp.postSSOFrom(redirectionLink, data);
}

function postSSOFrom(path, params, method) {
    method = method || 'post';

    const form = document.createElement('form');
    form.setAttribute('method', method);
    form.setAttribute('action', path);

    for (const key in params) {
        if (params.hasOwnProperty(key)) {
            const hiddenField = document.createElement('input');
            hiddenField.setAttribute('type', 'hidden');
            hiddenField.setAttribute('name', key);
            hiddenField.setAttribute('value', params[key]);

            form.appendChild(hiddenField);
        }
    }

    document.body.appendChild(form);
    form.submit();
}

function registerStore(store) {
    window.reduxStore = store;
}

export const MDTApp = {
    registerSettings: window.MDTApp.registerSettings,
    handlePostLoginAuthenticationRedirects,
    userExistsInConnect,
    initBootstrap,
    mergeDeep,
    goto,
    authenticate,
    getSetting,
    createQueryStringParam,
    getResourceAccess,
    showNotification,
    fetchWishlist,
    loadWishlist,
    loadWishlistCount,
    processUrl,
    logout,
    updateCheckoutData,
    saveScreenOverlay,
    setLoginData,
    getDeviceType,
    isMobile,
    isTablet,
    isMobileOrTablet,
    isDesktop,
    postSSOFrom,
    myloginRedirect,
    sso,
    setTileAction,
    whitelistedUrl,
    registerStore,
    getAwsConfig,
};
